export const LOCALE_COOKIE_KEY = "locale";
export const DEFAULT_LOCALE_GROUP = "en-US";
export const DEFAULT_LANGUAGE = "en";

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE_MOBILE = 20;
export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_SEARCH_URL_PARAMETERS = {ps: DEFAULT_PAGE_SIZE, pg: DEFAULT_PAGE_NUMBER};
export const CATEGORY_FACET_IN_URL = "catnav";
